import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 14,
    },
    css: css`
        &,
        span {
            color: ${getColor("text.main")} !important;
        }

        &:hover,
        &:focus {
            text-decoration: underline;
        }

        &,
        &:focus {
            outline: 0;
        }
    `,
};

signInExistingAccountStyles.forgotPasswordGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;

        > button {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        }
    `,
};

signInExistingAccountStyles.signInButton = {};
